









































import { Component, Vue, Prop } from 'vue-property-decorator'
import Button from '@/apps/open/components/Button'
import { getFunEmailInfo, updateFunEmailInfo, addFunEmailInfo } from '@/apps/open/services/email_admin'
import store from '@/apps/open/store'

interface EmailType {
  value: string,
  index: number,
  isNew?: boolean
}

@Component({
  components: {
    Button
  }
})
export default class EmailAdminDialogBody extends Vue {
  form: any = {
    emails: [],
    isSubscribe: false
  }
  addEmailForm: any = {
    email: ''
  }
  curInputEmail: string = ''
  test: string = ''
  curActionIdx: number = -1
  curActionType: string = ''

  emailRules = [
    { max: 80, message: '不超过80个字符', trigger: ['change'] },
    { required: true, type: 'email', message: '请输入正确的邮箱', trigger: ['change'] }
  ]

  delIdxRecords: Array<number> = []
  updateRecords: Array<EmailType> = []
  preEditEmail: string = ''
  preEditIdx: number = -1
  isAddConfig: boolean = false

  @Prop()
  submit!: Function

  @Prop()
  function_id!: number

  @Prop()
  is_wwo!: boolean

  mounted () {
    this.fetchEmailList()
  }

  get curEnterprise () {
    return store.getters['User/curEnterprise']
  }

  get companyEmail () {
    const userInfo = store.getters['User/userInfo']
    if (userInfo && userInfo.developer) {
      return userInfo.developer.email
    } else {
      return false
    }
  }

  async fetchEmailList () {
    const res = await getFunEmailInfo(this.function_id, this.curEnterprise && this.curEnterprise.developer_id)
    if (res.data.result === 'ok') {
      const resultData = res.data.object
      if (resultData) {
        let handledEmails: Array<EmailType> = []
        resultData.emails && resultData.emails.forEach((email: string, idx: number) => {
          if (email) handledEmails.push({ value: email, index: idx })
        })
        this.form.emails = handledEmails
        this.form.isSubscribe = resultData.is_subscribed
      } else if (resultData === null) {
        this.isAddConfig = true
      }
    }
  }

  addEmail () {
    let ref: any = this.$refs['addEmailForm']
    ref.validate((valid: any) => {
      if (valid) {
        if (this.form.emails.length < 6) {
          this.form.emails.push({ value: this.addEmailForm.email, isNew: true })
        }
      } else {
        return false
      }
    })
  }

  initCurAction () {
    this.curActionIdx = -1
    this.curActionType = ''
  }

  initPreEditData () {
    this.preEditIdx = -1
    this.preEditEmail = ''
  }

  setCurAction (idx: number, type: string) {
    if (this.preEditIdx > -1) {
      this.form.emails[this.preEditIdx].value = this.preEditEmail
      this.initPreEditData()
    }
    this.curActionIdx = idx
    this.curActionType = type
    if (type === 'edit') {
      this.preEditEmail = this.form.emails[idx].value
      this.preEditIdx = idx
    }
  }

  cancelEdit (idx: number) {
    this.form.emails[this.preEditIdx].value = this.preEditEmail
    this.initCurAction()
    this.initPreEditData()
  }

  findEmailAccIdx (indexVal: number) {
    return this.form.emails.find((email: EmailType) => email.index === indexVal)
  }

  editCurItem (idx: number, indexVal: number) {
    if (!this.isNewAddEmail(idx)) {
      this.updateRecords[indexVal] = this.findEmailAccIdx(indexVal)
      this.initPreEditData()
    }
    this.initCurAction()
  }

  isNewAddEmail (idx: number) {
    return this.form.emails[idx].isNew
  }

  delCurItem (idx: number) {
    this.setCurAction(idx, 'delete')
    this.$confirm('此操作将删除该邮箱, 是否继续?', '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning'
    }).then(() => {
      if (!this.isNewAddEmail(idx)) {
        // delete update-record item
        let indexVal = this.form.emails[idx].index
        // record action when email isn't new
        this.delIdxRecords.push(indexVal)
        if (this.findEmailAccIdx(indexVal)) {
          this.updateRecords.splice(indexVal, 1)
        }
      }
      this.form.emails.splice(idx, 1)
    })
  }

  submitEmailConf () {
    const el: any = this.$refs['form']
    const appendEmails: Array<string> = []
    this.form.emails.forEach((email: EmailType) => {
      if (email.isNew) appendEmails.push(email.value)
    })
    el.validate(async (valid: any) => {
      if (valid) {
        const developerIdParam = this.curEnterprise.developer_id ? { developer_id: this.curEnterprise.developer_id } : {}
        if (this.isAddConfig) {
          if (appendEmails.length < 1) {
            if (!this.form.isSubscribe) {
              this.$dialog.close()
              return
            } else if (!this.companyEmail) {
              this.$message.error('公司邮箱不存在, 请先设置公司邮箱')
              this.$dialog.close()
              return
            }
          }
          const param = {
            ...developerIdParam,
            function_id: this.function_id,
            is_wwo: this.is_wwo,
            emails: appendEmails.join(','),
            is_subscribed: this.form.isSubscribe
          }
          const res = await addFunEmailInfo(param)
          if (res.data.result === 'ok') {
            this.$message.success('更新成功')
            this.$dialog.close()
          }
        } else {
          if (this.form.isSubscribe && this.form.emails.length < 1) {
            this.$message.error('请先添加收件人')
            return
          }
          const updateIdxRecords: number[] = []
          const updateValueRecords: string[] = []
          this.updateRecords.forEach(info => {
            updateIdxRecords.push(info.index)
            updateValueRecords.push(info.value)
          })
          const param = {
            ...developerIdParam,
            function_id: this.function_id,
            is_subscribed: this.form.isSubscribe,
            append_emails: appendEmails.join(','),
            delete_index: this.delIdxRecords.join(','),
            modify_index: updateIdxRecords.join(','),
            modify_emails: updateValueRecords.join(',')
          }
          const res = await updateFunEmailInfo(param)
          if (res.data.result === 'ok') {
            this.$message.success('更新成功')
            this.$dialog.close()
          }
        }
      }
    })
  }
}
